export default {
  contact_provider: 'Neem contact op met uw provider om dit in te schakelen.',
};
